export default "__VITE_ASSET__DzR9HWBf__"